/* Lovable x Searchanise
   Renders the in-header search panel and the /search results page from the
   Searchanise search API, using the theme's own markup and classes
   (lv-product-card, lv-filter-drawer, lv-facet, lv-collection-*).
   Only loads when Theme settings > Searchanise API key is filled in
   (see layout/theme.liquid). Leave the key empty to use Shopify's search. */
(function () {
  var C = window.LV_SEARCH;
  if (!C || !C.apiKey) return;

  var ENDPOINT = 'https://searchserverapi1.com/getresults';
  var PAGE_SIZE = C.pageSize || 28;
  var SEARCH_URL = C.searchUrl || '/search';

  /* The hidden $500 "Bespoke Customization" add-on is a real product (so it can sit in the cart) but must never show in search. */
  function visible(items) {
    return (items || []).filter(function (it) { return !/\/products\/bespoke-customization(\?|$)/.test(String((it && it.link) || '')); });
  }

  /* Filters shown in the drawer, in this order (matched by Searchanise filter title). */
  var SHOW_FILTERS = ['Price', 'Availability', 'Color family', 'Material', 'Occasion', 'Theme', 'Season', 'Design line', 'Fits a phone'];
  var FILTER_LABEL = { Availability: 'Availability' };
  var AVAILABILITY_LABEL = { 'In Stock': 'In stock', 'Pre-Order': 'Pre-order', 'Out of Stock': 'Out of stock' };

  /* Flat color dot for each color family value (shown in two-up tiles). */
  var DOT_FOR_COLOR = {
    aqua: '#6fd0d0', beige: '#e3d3b8', black: '#121212', blue: '#2f5fa8', brown: '#7a4b2a',
    gold: 'linear-gradient(135deg, #f1d98a, #c9a227)', gray: '#8d9094', green: '#2f8f55',
    multicolor: 'conic-gradient(#d9362b, #f2b72e, #3aa55a, #2f6fd0, #8a3fb5, #d9362b)',
    orange: '#e9822b', pink: '#e98ab1', purple: '#6c3e9d', red: '#c0262d',
    silver: 'linear-gradient(135deg, #f2f3f5, #b4b8bf)', white: '#ffffff', yellow: '#f3d03c'
  };

  var SORTS = [
    { value: 'relevance', label: 'Sort: Relevance', by: 'relevance', order: 'desc' },
    { value: 'newest', label: 'Sort: Newest', by: 'created', order: 'desc' },
    { value: 'price-asc', label: 'Sort: Price, low to high', by: 'price', order: 'asc' },
    { value: 'price-desc', label: 'Sort: Price, high to low', by: 'price', order: 'desc' },
    { value: 'title-asc', label: 'Sort: Title, A-Z', by: 'title', order: 'asc' }
  ];

  /* ------------------------------------------------------------ utils */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  /* Theme settings > Product filters: which filters/values to show. Same syntax as the collection drawer. */
  function normVal(x) { return String(x == null ? '' : x).toLowerCase().replace(/['\u2019]/g, '').replace(/^\s+|\s+$/g, ''); }
  function parseRuleLines(text) {
    var map = {};
    String(text || '').split(/\r?\n/).forEach(function (line) {
      var k = line.indexOf(':');
      if (k < 0) return;
      var key = normVal(line.slice(0, k));
      var vals = line.slice(k + 1).split('|').map(function (v) { return v.replace(/^\s+|\s+$/g, ''); }).filter(Boolean);
      if (key && vals.length) map[key] = vals;
    });
    return map;
  }
  var FR = (window.LV_SEARCH && window.LV_SEARCH.filterRules) || {};
  var RULE_ORDER = String(FR.order || '').split(/\r?\n/).map(function (v) { return v.replace(/^\s+|\s+$/g, ''); }).filter(Boolean);
  var RULE_HIDDEN = parseRuleLines(FR.hidden), RULE_ONLY = parseRuleLines(FR.only), RULE_LAST = parseRuleLines(FR.last);
  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }
  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    var whole = Math.abs(n - Math.round(n)) < 0.005;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 });
  }
  function api(params) {
    var parts = ['api_key=' + encodeURIComponent(C.apiKey), 'output=json'];
    Object.keys(params).forEach(function (k) {
      var v = params[k];
      if (v === undefined || v === null || v === '') return;
      parts.push((k.indexOf('restrictBy[') === 0 ? k : encodeURIComponent(k)) + '=' + encodeURIComponent(v));
    });
    return fetch(ENDPOINT + '?' + parts.join('&')).then(function (r) { return r.json(); });
  }

  var ICON_SEARCH = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" width="18" height="18" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5" stroke-linecap="round"/></svg>';
  var ICON_CLOSE = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" width="16" height="16" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke-linecap="round"/></svg>';
  var ICON_CHEVRON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="16" height="16" data-lv-facet-chevron aria-hidden="true"><path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* Same markup as snippets/lovable-product-card.liquid. */
  function cardHTML(it) {
    var imgs = it.shopify_images || [];
    var primary = imgs[0] || it.image_link || '';
    var hover = imgs[1] || '';
    var vars = it.shopify_variants || [];
    var prices = vars.map(function (v) { return parseFloat(v.price); }).filter(function (n) { return !isNaN(n); });
    var min = prices.length ? Math.min.apply(null, prices) : parseFloat(it.price);
    var max = prices.length ? Math.max.apply(null, prices) : min;
    var label = min === max ? money(min) : money(min) + '–' + money(max);
    var available = vars.length
      ? vars.some(function (v) { return String(v.available) === '1' || v.available === true; })
      : parseInt(it.quantity, 10) > 0;
    var alt = (it.shopify_images_alt && it.shopify_images_alt[0]) || it.title;
    // Pre-order = tagged "pre-order", no stock left, still purchasable. (Sold-out products get no tag on cards.)
    var tagStr = '|' + String(it.tags || '').split('[:ATTR:]').join('|').toLowerCase() + '|';
    var preorder = tagStr.indexOf('|pre-order|') > -1 && !(parseInt(it.quantity, 10) > 0);
    return '<a href="' + esc(it.link) + '" class="lv-product-card" aria-label="' + esc(it.title) + ', ' + esc(label) + '">' +
      '<div class="lv-product-card__shell"><div class="lv-product-card__media">' +
      (primary ? '<img src="' + esc(primary) + '" alt="' + esc(alt) + '" loading="lazy" class="lv-product-card__image lv-product-card__image--primary">' : '') +
      (hover ? '<img src="' + esc(hover) + '" alt="" aria-hidden="true" loading="lazy" class="lv-product-card__image lv-product-card__image--hover">' : '') +
      (preorder ? '<span class="lv-product-card__preorder lv-eyebrow">Pre-Order</span>' : '') +
      '</div><div class="lv-product-card__info"><h3 class="lv-card-title lv-product-card__title">' + esc(it.title) + '</h3>' +
      '<p class="lv-body-small lv-product-card__price">' + esc(label) + '</p></div></div></a>';
  }

  function searchHref(q) { return SEARCH_URL + '?q=' + encodeURIComponent(q); }

  /* ============================================================
     1. Search panel in the header (opens from the search icon)
     ============================================================ */
  function initPanel() {
    var header = $('[data-lv-header]');
    if (!header) return;
    var trigger = $('.lv-header__icon-link--search', header);
    if (!trigger) return;

    var panel = document.createElement('div');
    panel.className = 'lv-search-panel';
    panel.hidden = true;
    panel.setAttribute('data-lv-search-panel', '');
    panel.innerHTML =
      '<div class="lv-search-panel__inner">' +
      '<form class="lv-search-panel__form" role="search" data-lv-sp-form>' +
      '<label class="lv-visually-hidden" for="LvSearchPanelInput">Search</label>' +
      '<input id="LvSearchPanelInput" class="lv-search-panel__input" name="lvq" type="text" inputmode="search" enterkeyhint="search" autocomplete="off" autocapitalize="off" spellcheck="false" placeholder="Search" data-lv-sp-input>' +
      '<button type="submit" class="lv-search-panel__submit" aria-label="Search">' + ICON_SEARCH + '</button>' +
      '<button type="button" class="lv-search-panel__close" data-lv-sp-close aria-label="Close search">' + ICON_CLOSE + '</button>' +
      '</form>' +
      '<div class="lv-search-panel__results" data-lv-sp-results aria-live="polite"></div>' +
      '</div>';
    header.appendChild(panel);

    var form = $('[data-lv-sp-form]', panel);
    var input = $('[data-lv-sp-input]', panel);
    var results = $('[data-lv-sp-results]', panel);
    var closeBtn = $('[data-lv-sp-close]', panel);
    var seq = 0;

    function trendingHTML() {
      var list = (C.trending || []).map(function (t) { return String(t).trim(); }).filter(Boolean);
      if (!list.length) return '';
      return '<div class="lv-search-panel__block"><p class="lv-eyebrow lv-search-panel__label">Trending searches</p><ul class="lv-search-panel__links">' +
        list.map(function (t) { return '<li><a href="' + esc(searchHref(t)) + '">' + esc(t) + '</a></li>'; }).join('') + '</ul></div>';
    }

    function showIdle() { results.innerHTML = trendingHTML(); }

    function render(q, j) {
      var items = visible(j.items);
      var ql = q.toLowerCase();
      var sugg = (j.suggestions || []).filter(function (s) {
        var sl = String(s).toLowerCase();
        return sl !== ql && sl !== ql + 's' && sl.indexOf('-') === -1;
      }).slice(0, 5);
      var total = j.totalItems || 0;
      var left = '';
      if (sugg.length) {
        left += '<div class="lv-search-panel__block"><p class="lv-eyebrow lv-search-panel__label">Suggestions</p><ul class="lv-search-panel__links">' +
          sugg.map(function (s) { return '<li><a href="' + esc(searchHref(s)) + '">' + esc(s) + '</a></li>'; }).join('') + '</ul></div>';
      }
      var right = '';
      if (items.length) {
        right = '<div class="lv-search-panel__grid">' + items.map(cardHTML).join('') + '</div>' +
          '<a class="lv-body-small lv-search-panel__all" href="' + esc(searchHref(j.correctedQuery || q)) + '">View all ' + total + ' result' + (total === 1 ? '' : 's') + '</a>';
      } else {
        right = '<p class="lv-body-small lv-search-panel__empty">No results for &ldquo;' + esc(q) + '&rdquo;. Try a different word, or browse <a href="/collections/shop-all">Shop All</a>.</p>';
      }
      var note = (j.correctedQuery && j.correctedQuery.toLowerCase() !== q.toLowerCase())
        ? '<p class="lv-body-small lv-search-panel__note">Showing results for &ldquo;' + esc(j.correctedQuery) + '&rdquo;</p>' : '';
      results.innerHTML = note + '<div class="lv-search-panel__cols"><div class="lv-search-panel__side">' + left + '</div><div class="lv-search-panel__main">' + right + '</div></div>';
    }

    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { seq++; showIdle(); return; }
      var mine = ++seq;
      api({ q: q, items: 'true', pages: 'false', categories: 'false', suggestions: 'true', suggestionsMaxResults: 5,
        queryCorrection: 'true', facets: 'false', maxResults: 8, pagesMaxResults: 3, sortBy: 'relevance', sortOrder: 'desc' })
        .then(function (j) { if (mine === seq) render(q, j); })
        .catch(function () { /* keep the last good state */ });
    }, 160);

    function open() {
      panel.hidden = false;
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      trigger.setAttribute('aria-expanded', 'true');
      if (!input.value.trim()) showIdle();
      input.focus();
      document.addEventListener('keydown', onKey);
      document.addEventListener('click', onDocClick, true);
    }
    function close() {
      panel.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('click', onDocClick, true);
      setTimeout(function () { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 220);
    }
    function onKey(e) { if (e.key === 'Escape') { close(); trigger.focus(); } }
    function onDocClick(e) { if (!panel.contains(e.target) && !trigger.contains(e.target)) close(); }

    trigger.setAttribute('data-no-transition', ''); // the theme's page-transition script would otherwise navigate away
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      if (panel.classList.contains('is-open')) close(); else open();
    });
    closeBtn.addEventListener('click', close);
    input.addEventListener('input', run);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = input.value.trim();
      if (q) window.location.href = searchHref(q);
    });
  }

  /* ============================================================
     2. /search results page
     ============================================================ */
  function initPage() {
    var root = $('[data-lv-sn-app]');
    if (!root) return;

    var params = new URLSearchParams(window.location.search);
    var state = { q: '', sort: 'relevance', price: '', filters: {}, exact: false, loaded: 0, total: 0, busy: false };
    var facetDefs = [];            // [{title, slug, attribute, buckets, type}]
    var attrBySlug = {};

    root.innerHTML =
      '<form id="SearchFiltersForm" class="lv-collection-form" data-lv-collection-form data-lv-sn-form>' +
      '<div class="lv-collection-toolbar" data-lv-collection-toolbar><div class="lv-collection-toolbar__inner">' +
      '<button type="button" class="lv-collection-toolbar__filter-btn" data-lv-filter-open aria-controls="LvFilterDrawer" aria-expanded="false">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" width="14" height="14" aria-hidden="true"><path d="M4 6h16M8 12h8M11 18h2" stroke-linecap="round"/></svg>' +
      '<span class="lv-body-small" data-lv-sn-filter-label>Filter</span></button>' +
      '<p class="lv-body-small lv-collection-toolbar__count" aria-live="polite" data-lv-sn-count></p>' +
      '<div class="lv-collection-toolbar__sort"><label for="LvSortBy" class="lv-visually-hidden">Sort by</label>' +
      '<select name="sort_by" id="LvSortBy" class="lv-collection-toolbar__select" data-lv-sort-select>' +
      SORTS.map(function (s) { return '<option value="' + s.value + '">' + s.label + '</option>'; }).join('') + '</select>' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="14" height="14" class="lv-collection-toolbar__chevron" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/></svg></div>' +
      '</div></div>' +
      '<p class="lv-body-small lv-collection-toolbar__count-mobile" aria-live="polite" data-lv-sn-count-mobile></p>' +
      '<div data-lv-sn-chips></div>' +
      '<div class="lv-filter-drawer" data-lv-filter-drawer id="LvFilterDrawer" role="dialog" aria-modal="true" aria-label="Filter products" hidden>' +
      '<button type="button" class="lv-filter-drawer__backdrop" data-lv-filter-close aria-label="Close filters"></button>' +
      '<div class="lv-filter-drawer__panel" data-lv-filter-panel><div class="lv-filter-drawer__header"><span class="lv-eyebrow">Filter</span>' +
      '<button type="button" class="lv-filter-drawer__close" data-lv-filter-close aria-label="Close filters">' + ICON_CLOSE + '</button></div>' +
      '<div class="lv-filter-drawer__body" data-lv-sn-facets></div>' +
      '<div class="lv-filter-drawer__footer"><button type="button" class="lv-body-small lv-filter-drawer__clear" data-lv-filter-clear>Clear</button>' +
      '<button type="submit" class="lv-btn-base lv-btn-solid lv-filter-drawer__apply" data-lv-filter-apply>Apply<span data-lv-filter-apply-count></span></button></div>' +
      '</div></div>' +
      '<div class="lv-collection-products"><div id="SearchProductGrid" class="lv-collection-grid" data-lv-sn-grid></div><div data-lv-sn-sentinel style="height:1px"></div></div>' +
      '</form>';

    var form = $('[data-lv-sn-form]', root);
    var grid = $('[data-lv-sn-grid]', root);
    var sentinel = $('[data-lv-sn-sentinel]', root);
    var facetsBox = $('[data-lv-sn-facets]', root);
    var chipsBox = $('[data-lv-sn-chips]', root);
    var sortSel = $('[data-lv-sort-select]', root);
    var titleEl = $('[data-lv-sn-title]');
    var searchInput = $('[data-lv-sn-input]');

    /* ---------- URL <-> state ---------- */
    function readUrl() {
      var p = new URLSearchParams(window.location.search);
      state.q = (p.get('q') || '').trim();
      state.sort = p.get('sort') || 'relevance';
      state.price = p.get('price') || '';
      state.exact = p.get('exact') === '1';
      state.filters = {};
      p.forEach(function (value, key) {
        if (key.indexOf('f_') === 0) {
          var s = key.slice(2);
          (state.filters[s] = state.filters[s] || []).push(value);
        }
      });
    }
    function writeUrl(push) {
      var p = new URLSearchParams();
      if (state.q) p.set('q', state.q);
      if (state.sort && state.sort !== 'relevance') p.set('sort', state.sort);
      if (state.price) p.set('price', state.price);
      if (state.exact) p.set('exact', '1');
      Object.keys(state.filters).forEach(function (s) {
        state.filters[s].forEach(function (v) { p.append('f_' + s, v); });
      });
      var url = window.location.pathname + '?' + p.toString();
      if (push) history.pushState(null, '', url); else history.replaceState(null, '', url);
    }

    /* ---------- request building ---------- */
    function restrictParams() {
      var r = {};
      Object.keys(state.filters).forEach(function (s) {
        var attr = attrBySlug[s];
        if (attr && state.filters[s].length) r['restrictBy[' + attr + ']'] = state.filters[s].join('|');
      });
      if (state.price) r['restrictBy[price]'] = state.price;
      return r;
    }
    function request(startIndex, wantFacets) {
      var sort = SORTS.filter(function (s) { return s.value === state.sort; })[0] || SORTS[0];
      var p = { q: state.q, items: 'true', pages: 'false', categories: 'false', suggestions: 'true',
        suggestionsMaxResults: 3, queryCorrection: state.exact ? 'false' : 'true', facets: wantFacets ? 'true' : 'false', startIndex: startIndex,
        maxResults: PAGE_SIZE, pagesMaxResults: 4, sortBy: sort.by, sortOrder: sort.order };
      var r = restrictParams();
      Object.keys(r).forEach(function (k) { p[k] = r[k]; });
      return api(p);
    }

    /* ---------- facets ---------- */
    function indexFacets(facets) {
      facetDefs = [];
      attrBySlug = {};
      (RULE_ORDER.length ? RULE_ORDER : SHOW_FILTERS).forEach(function (title) {
        var f = (facets || []).filter(function (x) { return normVal(x.title) === normVal(title); })[0];
        if (!f) return;
        var s = slug(f.title);
        attrBySlug[s] = f.attribute;
        facetDefs.push({ title: f.title, slug: s, attribute: f.attribute, type: f.type, buckets: f.buckets || [] });
      });
    }
    function seasonKey(v) {
      var m = String(v).match(/(\d{2,4})\s*$/);
      return m ? -parseInt(m[1], 10) : 0;
    }
    function sortedBuckets(def) {
      var b = def.buckets.slice();
      if (def.slug === 'fits-a-phone') {
        /* Yes/no field: only offer the Yes option. */
        return b.filter(function (x) { return /^(true|yes|1)$/i.test(String(x.value)); });
      }
      if (def.slug === 'season') {
        b.sort(function (a, c) { return seasonKey(a.value) - seasonKey(c.value) || String(a.value).localeCompare(c.value); });
      } else if (def.slug !== 'price') {
        b.sort(function (a, c) { return String(a.value).localeCompare(c.value); });
      }
      return applyValueRules(def, b);
    }
    function applyValueRules(def, b) {
      var key = normVal(def.title);
      var chosen = (state.filters[def.slug] || []).map(normVal);
      var only = RULE_ONLY[key], hidden = (RULE_HIDDEN[key] || []).map(normVal), last = (RULE_LAST[key] || []).map(normVal);
      var lab = function (x) { return normVal(x.value); };
      if (only) {
        var out = [];
        only.forEach(function (o) { b.forEach(function (x) { if (lab(x) === normVal(o)) out.push(x); }); });
        return out;
      }
      b = b.filter(function (x) { return hidden.indexOf(lab(x)) < 0 || chosen.indexOf(lab(x)) > -1; });
      var front = b.filter(function (x) { return last.indexOf(lab(x)) < 0; });
      var back = [];
      last.forEach(function (l) { b.forEach(function (x) { if (lab(x) === l) back.push(x); }); });
      return front.concat(back);
    }
    function facetHTML(def) {
      var label = FILTER_LABEL[def.title] || def.title;
      var body = '';
      if (def.slug === 'price') {
        var b = def.buckets[0] || {};
        var cur = state.price ? state.price.split(',') : ['', ''];
        body = '<div class="lv-facet__price-range"><label class="lv-visually-hidden" for="LvPriceMin">From</label>' +
          '<input type="number" id="LvPriceMin" name="price_min" value="' + esc(cur[0]) + '" placeholder="' + Math.floor(parseFloat(b.left) || 0) + '" class="lv-filter-drawer__number">' +
          '<span aria-hidden="true">–</span><label class="lv-visually-hidden" for="LvPriceMax">To</label>' +
          '<input type="number" id="LvPriceMax" name="price_max" value="' + esc(cur[1]) + '" placeholder="' + Math.ceil(parseFloat(b.right) || 0) + '" class="lv-filter-drawer__number"></div>';
      } else {
        var chosen = state.filters[def.slug] || [];
        var isColor = def.slug === 'color-family';
        body = '<ul class="lv-facet__values' + (isColor ? ' lv-facet__values--tiles' : '') + '">' + sortedBuckets(def).map(function (bk, i) {
          var v = String(bk.value);
          var shown = def.slug === 'availability' ? (AVAILABILITY_LABEL[v] || v) : (def.slug === 'fits-a-phone' ? 'Yes' : v);
          var dot = isColor && DOT_FOR_COLOR[v.toLowerCase()];
          var id = 'lvf-' + def.slug + '-' + i;
          return '<li><label class="lv-facet-option' + (isColor ? ' lv-facet-option--tile' : '') + (chosen.indexOf(v) > -1 ? ' is-active' : '') + '" for="' + id + '">' +
            '<input type="checkbox" id="' + id + '" name="f_' + def.slug + '" value="' + esc(v) + '" data-lv-facet-input' + (chosen.indexOf(v) > -1 ? ' checked' : '') + '>' +
            (dot ? '<span class="lv-facet-option__dot" style="--lv-dot:' + esc(dot) + '" aria-hidden="true"></span>'
                 : '<span class="lv-facet-option__checkbox" aria-hidden="true"></span>') +
            '<span class="lv-facet-option__label">' + esc(shown) + '</span></label></li>';
        }).join('') + '</ul>';
      }
      return '<div class="lv-facet is-open" data-lv-facet><button type="button" class="lv-facet__summary" data-lv-facet-toggle aria-expanded="true">' +
        '<span class="lv-eyebrow lv-heading-feature">' + esc(label) + '</span>' + ICON_CHEVRON + '</button>' +
        '<div class="lv-facet__panel" data-lv-facet-panel><div class="lv-facet__panel-inner">' + body + '</div></div></div>';
    }
    function renderFacets() {
      facetsBox.innerHTML = facetDefs.map(facetHTML).join('');
      $$('[data-lv-facet]', facetsBox).forEach(function (facet) {
        var trig = $('[data-lv-facet-toggle]', facet);
        trig.addEventListener('click', function () {
          var open = facet.classList.toggle('is-open');
          trig.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    }

    /* ---------- chips + counts ---------- */
    function activeCount() {
      var n = state.price ? 1 : 0;
      Object.keys(state.filters).forEach(function (s) { n += state.filters[s].length; });
      return n;
    }
    function renderChips() {
      var chips = [];
      facetDefs.forEach(function (def) {
        if (def.slug === 'price') {
          if (state.price) {
            var pr = state.price.split(',');
            chips.push({ label: 'Price: ' + money(pr[0] || 0) + ' – ' + (pr[1] ? money(pr[1]) : 'up'), remove: function () { state.price = ''; } });
          }
          return;
        }
        (state.filters[def.slug] || []).forEach(function (v) {
          var shown = def.slug === 'availability' ? (AVAILABILITY_LABEL[v] || v) : (def.slug === 'fits-a-phone' ? 'Yes' : v);
          chips.push({ label: (FILTER_LABEL[def.title] || def.title) + ': ' + shown, remove: function () {
            state.filters[def.slug] = state.filters[def.slug].filter(function (x) { return x !== v; });
            if (!state.filters[def.slug].length) delete state.filters[def.slug];
          } });
        });
      });
      if (!chips.length) { chipsBox.innerHTML = ''; return; }
      chipsBox.innerHTML = '<div class="lv-collection-chips"><ul class="lv-collection-chips__list">' +
        chips.map(function (c, i) {
          return '<li><button type="button" class="lv-collection-chips__chip" data-lv-sn-chip="' + i + '">' + esc(c.label) + ICON_CLOSE.replace('width="16" height="16"', 'width="12" height="12"') +
            '<span class="lv-visually-hidden">Remove ' + esc(c.label) + '</span></button></li>';
        }).join('') + '</ul><button type="button" class="lv-body-small lv-collection-chips__clear" data-lv-sn-clear-all>Clear all</button></div>';
      $$('[data-lv-sn-chip]', chipsBox).forEach(function (btn) {
        btn.addEventListener('click', function () { chips[parseInt(btn.getAttribute('data-lv-sn-chip'), 10)].remove(); apply(true); });
      });
      $('[data-lv-sn-clear-all]', chipsBox).addEventListener('click', function () { state.filters = {}; state.price = ''; apply(true); });
    }
    function renderCounts() {
      var n = activeCount();
      $('[data-lv-sn-filter-label]', root).textContent = 'Filter' + (n ? ' (' + n + ')' : '');
      var txt = state.total + (state.total === 1 ? ' Product' : ' Products');
      $('[data-lv-sn-count]', root).textContent = txt;
      $('[data-lv-sn-count-mobile]', root).textContent = txt.toLowerCase();
      var applyCount = $('[data-lv-filter-apply-count]', root);
      if (applyCount) applyCount.textContent = ' (' + state.total + ')';
      sortSel.value = state.sort;
    }
    function renderTitle(j) {
      if (!titleEl) return;
      if (!state.q) { titleEl.textContent = 'Search'; return; }
      var shown = (j && j.correctedQuery && j.correctedQuery.toLowerCase() !== state.q.toLowerCase()) ? j.correctedQuery : state.q;
      titleEl.innerHTML = 'Results for &ldquo;' + esc(shown) + '&rdquo;';
      if (shown !== state.q) {
        var note = document.createElement('p');
        note.className = 'lv-body-small lv-search-header__note';
        note.innerHTML = 'Showing results for &ldquo;' + esc(shown) + '&rdquo;. Search instead for <a href="' + esc(searchHref(state.q)) + '&exact=1">' + esc(state.q) + '</a>';
        var old = $('.lv-search-header__note');
        if (old) old.remove();
        titleEl.insertAdjacentElement('afterend', note);
      } else {
        var o = $('.lv-search-header__note'); if (o) o.remove();
      }
      document.title = 'Search: ' + shown + ' – ' + (C.shopName || document.title.split('–').pop().trim());
    }
    /* ---------- loading ---------- */
    var epoch = 0;
    function load() {
      var mine = ++epoch;
      state.loaded = 0;
      grid.setAttribute('aria-busy', 'true');
      if (!state.q) { grid.innerHTML = '<p class="lv-collection-empty">Type a word above to search.</p>'; state.total = 0; renderCounts(); return; }
      var hadMap = Object.keys(attrBySlug).length > 0;
      request(0, true).then(function (j) {
        if (mine !== epoch) return;
        // A deep link carries filter slugs that we can only map to Searchanise filters after the first response.
        if (!hadMap && Object.keys(state.filters).length + (state.price ? 1 : 0) > 0) {
          indexFacets(j.facets);
          return request(0, true).then(function (j2) { if (mine === epoch) finish(j2); });
        }
        finish(j);
      }).catch(function () {
        grid.innerHTML = '<p class="lv-collection-empty">Search is unavailable right now. Please try again in a moment.</p>';
      });
    }
    function finish(j) {
      if (j.facets && j.facets.length) indexFacets(j.facets);
      state.total = j.totalItems || 0;
      var raw = j.items || [];
      var items = visible(raw);
      state.loaded = raw.length;
      grid.innerHTML = items.length ? items.map(cardHTML).join('') :
        '<p class="lv-collection-empty">No products match &ldquo;' + esc(state.q) + '&rdquo;' + (activeCount() ? ' with these filters.' : '.') + '</p>';
      grid.removeAttribute('aria-busy');
      renderTitle(j); renderFacets(); renderChips(); renderCounts();
    }
    function loadMore() {
      if (state.busy || state.loaded >= state.total || !state.q) return;
      state.busy = true;
      var mine = epoch;
      request(state.loaded, false).then(function (j) {
        if (mine !== epoch) return;
        var raw = j.items || [];
        grid.insertAdjacentHTML('beforeend', visible(raw).map(cardHTML).join(''));
        state.loaded += raw.length;
      }).catch(function () {}).then(function () { state.busy = false; });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) loadMore();
      }, { rootMargin: '900px 0px' }).observe(sentinel);
    }

    /* ---------- apply / events ---------- */
    function readDraft() {
      var f = {};
      $$('[data-lv-facet-input]', facetsBox).forEach(function (inp) {
        if (!inp.checked) return;
        var s = inp.name.slice(2);
        (f[s] = f[s] || []).push(inp.value);
      });
      state.filters = f;
      var mn = $('[name="price_min"]', facetsBox), mx = $('[name="price_max"]', facetsBox);
      state.price = (mn && mx && (mn.value || mx.value)) ? ((mn.value || '0') + ',' + (mx.value || '999999')) : '';
    }
    function closeDrawer() {
      var drawer = $('[data-lv-filter-drawer]', root);
      var btn = $('[data-lv-filter-close]', drawer);
      if (drawer && !drawer.hidden && btn) btn.click();
    }
    function apply(push) { writeUrl(push !== false); load(); }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      readDraft();
      state.sort = sortSel.value;
      closeDrawer();
      apply(true);
    });
    window.addEventListener('popstate', function () { readUrl(); load(); });

    if (searchInput) {
      searchInput.value = '';
      var sform = searchInput.closest('form');
      if (sform) sform.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = searchInput.value.trim();
        if (q) window.location.href = searchHref(q);
      });
    }

    readUrl();
    if (searchInput) searchInput.value = state.q;
    // Make sure the toolbar reflects the URL before the first response arrives.
    sortSel.value = state.sort;
    load();
  }

  function boot() { initPanel(); initPage(); }
  boot();
})();
